// src/services/interestFitService.js
//
// The interest fit report: how one listing and one provider line up, aspect by
// aspect, computed server side (backend matching/fit/interest-fit.util.ts).
// Read only. The confirmation dialog shows it before any interest is recorded.
import api from '../api';
import { handleApiError } from '../utils/errorHandler';

/** The report the signed-in provider reads before expressing interest. */
export const getListingFit = async (listingId) => {
  if (!listingId) throw new Error('listingId is required');
  try {
    const response = await api.get(
      `/matching/fit/listing/${encodeURIComponent(String(listingId))}`,
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error, 'Could not compare this job with your preferences');
  }
};

/** The report a company reads before connecting with a provider on one of its listings. */
export const getProviderFit = async (providerProfileId, listingId) => {
  if (!providerProfileId) throw new Error('providerProfileId is required');
  if (!listingId) throw new Error('listingId is required');
  try {
    const response = await api.get(
      `/matching/fit/provider/${encodeURIComponent(String(providerProfileId))}`,
      { params: { listingId: String(listingId) } },
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error, 'Could not compare this provider with your listing');
  }
};

const interestFitService = { getListingFit, getProviderFit };
export default interestFitService;
